import { render, staticRenderFns } from "./legalPersonInfo.vue?vue&type=template&id=4cfb128c&scoped=true"
import script from "./legalPersonInfo.vue?vue&type=script&lang=js"
export * from "./legalPersonInfo.vue?vue&type=script&lang=js"
import style0 from "./legalPersonInfo.vue?vue&type=style&index=0&id=4cfb128c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfb128c",
  null
  
)

export default component.exports